import FbbcPortalDemoPoster from "../../../../../images/posters/fbbc/walkthroughs/portal-walkthrough.webp";

const fbbcWalkthroughs = [
  { 
    "title": "Fit Body Coaching Portal Walkthrough",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/July+2026+FBBC+Portal+Demo.mp4",
    "thumbnail": FbbcPortalDemoPoster,
    "length": "38:58",
    "starred": true,
    "timestamps": [
      {
        "title": "0:00 - Intro",
        "time": 0
      },
      {
        "title": "0:20 - Coaching Overview",
        "time": 20
      },
      {
        "title": "5:18 - Inspect Account",
        "time": 318
      },
      {
        "title": "8:44 - Edit Account",
        "time": 524
      },
      {
        "title": "11:25 - Practice Mode/Pause your Goal",
        "time": 685
      },
      {
        "title": "14:30 - Meal Planning",
        "time": 870
      },
      {
        "title": "16:04 - Messaging",
        "time": 964
      },
      {
        "title": "17:07 - Groups",
        "time": 1027
      },
      {
        "title": "18:38 - Check-in Forms",
        "time": 1118
      },
      {
        "title": "26:26 - Team Management",
        "time": 1586
      },
      {
        "title": "28:30 - Client Management",
        "time": 1710
      },
      {
        "title": "30:08 - Billing",
        "time": 1808
      },
      {
        "title": "31:58 - Adding You & Your Team As Clients (Friends Feature)",
        "time": 1918
      },
      {
        "title": "38:40 - Conclusion",
        "time": 2320
      }
    ]
  },
];

export default fbbcWalkthroughs;
